<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        货源供应
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>

      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @row-click="indexMethod"
      >
        <el-table-column align="center" prop="order_by" label="资质图片" width="80">
          <template slot-scope="scope">
            <div>
              <img style="width:60px;height:60px" :src="scope.row.aptitude" alt />
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="brand" label="产品品牌" width="110"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="company" label="企业名称"></el-table-column>
        <el-table-column align="center" prop="company_type" label="企业类型" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="price" label="单价" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="product_type" label="类型/型号" show-overflow-tooltip></el-table-column>
        <el-table-column
          width="120"
          align="center"
          label="操作"
          type="index"
          
        >
          <template>
            <span class="binaji" @click="setgoods()">查看详情</span>
          </template>
        </el-table-column>
      </el-table>
      <!--  <el-table-column align="center" prop="order_by" label="产品图片" width="80">
          <template slot-scope="scope">
            <div>
              <img style="width:60px;height:60px" :src="scope.row.image" alt />
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="order_by" label="资质图片" width="80">
          <template slot-scope="scope">
            <div>
              <img style="width:60px;height:60px" :src="scope.row.aptitude" alt />
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="brand" label="产品品牌" width="110"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="company" label="企业名称"></el-table-column>
        <el-table-column align="center" prop="company_type" label="企业类型" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="price" label="单价" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="product_type" label="类型/型号" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="detail" label="产品描述" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="link_member" label="企业联系人" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="number" label="现货数量" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="output" label="日排产量" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="phone" label="手机" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="shipments_address" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="shipments_date" label="发货时间" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" prop="shipments_type" label="物流方式" show-overflow-tooltip></el-table-column>-->
      <div>
        <el-pagination
          class="goodslist_bom_page"
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          hide-on-single-page
          @current-change="pagechange"
        ></el-pagination>
        <!-- hide-on-single-page -->
      </div>
    </div>
    <noAccess v-else></noAccess>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="40%">
      <div style="line-height:26px">
        <div style="display:flex">
          <span>产品图片 ：</span>
          <span>
            <img width="60" :src="info.image" alt />
          </span>
        </div>
        <div style="display:flex">
          <span>资质图片 ：</span>
          <span>
            <img width="60" :src="info.aptitude" alt />
          </span>
        </div>
        <div>
          <span>产品品牌 ：</span>
          <span>{{info.brand}}</span>
        </div>
        <div>
          <span>企业名称 ：</span>
          <span>{{info.company}}</span>
        </div>
        <div>
          <span>企业类型 ：</span>
          <span>{{info.company_type}}</span>
        </div>
        <div>
          <span>单价 ：</span>
          <span>{{info.price}}</span>
        </div>
        <div>
          <span>类型/型号 ：</span>
          <span>{{info.product_type}}</span>
        </div>
        <div>
          <span>产品描述 ：</span>
          <span>{{info.detail}}</span>
        </div>
        <div>
          <span>企业联系人 ：</span>
          <span>{{info.link_member}}</span>
        </div>
        <div>
          <span>现货数量 ：</span>
          <span>{{info.number}}</span>
        </div>
        <div>
          <span>日排产量 ：</span>
          <span>{{info.output}}</span>
        </div>
        <div>
          <span>手机 ：</span>
          <span>{{info.phone}}</span>
        </div>
        <div>
          <span>邮箱 ：</span>
          <span>{{info.email}}</span>
        </div>
        <div>
          <span>备注 ：</span>
          <span>{{info.remark}}</span>
        </div>
        <div>
          <span>地址 ：</span>
          <span>{{info.shipments_address}}</span>
        </div>
        <div>
          <span>发货时间 ：</span>
          <span>{{info.shipments_date}}</span>
        </div>
        <div>
          <span>物流方式 ：</span>
          <span>{{info.shipments_type}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 15,
      page: null,
      total: null,
      tableData: [],
      dialogVisible: false,
      info: {}
    };
  },
  created() {
    this.$store.state.topActiveId = 12;
    this.$store.state.leftTitle = "货源供应";
    this.geting();
  },
  watch: {},
  methods: {
    indexMethod(row, column, cell, event) {
      this.info = row
    },
    setgoods() {
      this.dialogVisible = true;
   
    },
    pagechange(page) {
      this.geting(page);
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/SupplySupplierList", {
          params: {
            username: this.username,
            token: this.token,
            page
          }
        })
        .then(res => {
          this.tableData = [];
          this.loading = false;
          if (res.data.status == "success") {
            this.page = res.data.data.page;
            this.total = res.data.data.total;
            this.tableData = res.data.data.results;
          }else{
            if(res.data.msg == '无权访问')
            {
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1022px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>